import { useMasteryMapListApi } from '@api/mastery-map/mastery-map-list.hook'
import { onDisciplineReady } from '@hooks/discipline/on-discipline-ready.hook'

import { defineNuxtRouteMiddleware } from '#app'

export default defineNuxtRouteMiddleware(() => {
  const { fetchMasteryMaps } = useMasteryMapListApi()

  onDisciplineReady(() => {
    void fetchMasteryMaps()
  }, { hook: 'NONE' })
})
